import script from "./ConfigAsistencia.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigAsistencia.vue?vue&type=script&setup=true&lang=js"

import "./ConfigAsistencia.vue?vue&type=style&index=0&id=6eb2119e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eb2119e"]])

export default __exports__